import { useRef, useCallback, useEffect } from "react";

const useSafeTimeout = () => {
  const timeoutIds = useRef(new Set());

  const safeSetTimeout = useCallback((fn, delay) => {
    const id = setTimeout(() => {
      timeoutIds.current.delete(id);
      fn();
    }, delay);
    timeoutIds.current.add(id);
    return id;
  }, []);

  const safeClearTimeout = useCallback((id) => {
    clearTimeout(id);
    timeoutIds.current.delete(id);
  }, []);

  useEffect(() => {
    return () => {
      timeoutIds.current.forEach((id) => clearTimeout(id));
      timeoutIds.current.clear();
    };
  }, []);

  return { safeSetTimeout, safeClearTimeout };
};

export default useSafeTimeout;
